import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token) => {
    if (!token) {
        return true; // Token is missing, consider it expired
    }
    try {
        const { exp } = jwtDecode(token); // Decode the token to get the expiration time
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        return exp < currentTime; // Check if the token is expired
      } catch (error) {
        console.error("Error decoding token:", error);
        return true; // If decoding fails, consider the token expired
      }
}